import { combineReducers } from '@reduxjs/toolkit';
import React from 'react';
import { searchReducer } from './features/search/ducks/search/reducer';
import { employeesReducer } from './features/users/ducks/user/reducer';

const index = () => {
    return <div></div>;
};

export default index;

export const smoelenboekReducer = combineReducers({
    employees: employeesReducer,
    search: searchReducer,
});
